"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Colors = require("../../constants/Colors");

var _templateObject;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var StyledAnchor = /*#__PURE__*/_styledComponents.default.a.withConfig({
  displayName: "Link__StyledAnchor",
  componentId: "sc-1ogxkbr-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    color: ", "\n    text-decoration: none;\n\n    :link {\n        color: ", "\n    }\n    :active {\n        color: ", "\n    }\n    :visited {\n        color: ", "\n    }\n    :hover {\n        color: ", "\n        text-decoration: underline;\n    }\n"])), _Colors.java, _Colors.java, _Colors.java, _Colors.java, _Colors.java);

var Link = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Link, _Component);

  var _super = _createSuper(Link);

  function Link() {
    (0, _classCallCheck2.default)(this, Link);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Link, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(StyledAnchor, this.props);
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        href: 'javascript:void(0);'
      };
    }
  }]);
  return Link;
}(_react.Component);

exports.default = Link;